import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { Theme } from "../../../../types/theme.types";

const { get } = request;
const initialRoute = "admin/employee-page-design";

export const getThemeColors = async (): Promise<Theme[]> => {
	try {
		const endpoint = `${initialRoute}/theme-color`;
		const response = await get(endpoint, headers);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getThemeColorByGroupNumber = async (group_number: number): Promise<Theme> => {
	try {
		const endpoint = `${initialRoute}/theme-color/${group_number}`;
		const response = await get(endpoint);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ || message === MESSAGE.get.empty) {
				const {
					data: { result }
				} = response;
				if (result) {
					// console.log("result", result);
					return result;
				} else {
					const theme: Theme = {
						primary_color: "#e0e0e0",
						secondary_color: "#4e4e4e",
						button: {
							background_color: "#e0e0e0",
							color: "#000000"
						},
						top_bar: {
							color: "#fffff",
							background_color: "#7e7e7e"
						},
						theme_style: "theme_style_1",
						group_number
					};
					return theme;
				}
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const theme = {
	getThemeColorByGroupNumber,
	getThemeColors
};
